import { Box } from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../state/context/auth.context";
import ConnectWallet from "../Components/Common/ConnectWallet.component";

const LoginPage = () => {
    const navigate = useNavigate();
    const { state } = useContext(AuthContext);
    const { address, isConnected } = state.user || {};
    const location = useLocation();

    const from = location.state?.from?.pathname || "/floki";

    useEffect(() => {
        if (isConnected) {
            navigate(from, { replace: true }); // Use { replace: true } for a cleaner history
        }
    }
        , [isConnected]);


    return <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>

        <ConnectWallet />

    </Box>;
};

export default LoginPage;